import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Flex, Text } from 'rebass/styled-components';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';

export const CampaignRenderer = ({ value, data }) => {
  const { slug } = useSelector(activeNetworkSelector);
  const history = useHistory();

  if (!value) return null;

  return (
    <Flex
      onClick={() => history.push(`/networks/${slug}/sourcing-agent/campaigns/${data.original.id}`)}
      alignItems="center"
      height="100%"
      sx={{ gap: '8px', p: '8px', pl: '8px', cursor: 'pointer' }}
    >
      <Flex
        alignItems="center"
        sx={{
          gap: '6px',
          px: '8px',
          py: '4px',
          borderRadius: '4px',
          textDecoration: 'none',
        }}
      >
        <Text
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontFamily: 'Silka',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '24px',
          }}
        >
          {value}
        </Text>
      </Flex>
    </Flex>
  );
};

CampaignRenderer.propTypes = {
  value: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};
